<app-nav [titulo]="property ? 'Modificar propiedad ' + property.direccion.calle + ' ' + property.direccion.numero : 'Nueva propiedad'" [descripcion]="property ? 'Aquí podrá ver todos los detalles de la propiedad seleccionada y modificarlos.' : 'Por favor complete todos los datos de la nueva propiedad.'">
    <div class="edit-property basic-avm-editor">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab [label]="property ? 'Edición' : 'Creación manual'">
                <mat-horizontal-stepper class="form-stepper" [linear]="!property" #stepper>
                    <mat-step [completed]="!!broker" *ngIf="showBrokerSelectionStep">
                        <div class="form-step broker-selector">
                            <ng-template matStepLabel>Agente asociado</ng-template>
                            <h3 class="form-step-title">
                                Agente
                            </h3>
                            <span class="form-step-description">
                                Debe seleccionar el agente asociado a la cotización.
                            </span>
                            <button mat-raised-button color="primary" type="button" class="garantor-button mini select-broker-button" (click)="openSelectBrokerModal()" *ngIf="!broker">
                                Seleccionar agente
                            </button>
                            <div class="selected-broker" *ngIf="broker">
                                <span class="broker-name">{{ broker.nombre }} {{ broker.apellido }}</span>
                                <button mat-icon-button type="button" class="delete-broker-button" color="accent" (click)="broker = undefined" [disabled]="property">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="stepper.next()" *ngIf="broker">
                                Siguiente
                            </button>
                        </div>
                    </mat-step>
                    <mat-step [completed]="addressSectionFG.valid">
                        <ng-template matStepLabel>Dirección</ng-template>
                        <form class="form-step address-step" [formGroup]="addressSectionFG" (ngSubmit)="addressSectionFG.valid && stepper.next()">
                            <h3 class="form-step-title">
                                Dirección
                            </h3>
                            <span class="form-step-description">
                                Complete los datos de la dirección de la oficina.
                            </span>
                            <app-address-form [formGroup]="addressSectionFG"></app-address-form>
                            <div class="form-step-buttons">
                                <button mat-raised-button color="primary" class="garantor-button next">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createProperty()" *ngIf="property">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step [completed]="rentalSectionFG.valid">
                        <ng-template matStepLabel>Información del alquiler</ng-template>
                        <form class="form-step" [formGroup]="rentalSectionFG" (ngSubmit)="rentalSectionFG.valid && stepper.next()">
                            <h3 class="form-step-title">
                                Información del alquiler
                            </h3>
                            <span class="form-step-description">
                                Para comenzar complete los detalles sobre el alquiler de la propiedad.
                            </span>
                            <div class="form-line">
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <span matPrefix>$ &nbsp;</span>
                                    <mat-label>Valor del alquiler</mat-label>
                                    <input matInput formControlName="alquiler" type="number">
                                    <mat-error *ngIf="rentalSectionFG.controls['alquiler'].hasError('required')">
                                        Por favor ingrese un valor para el alquiler
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <span matPrefix>$ &nbsp;</span>
                                    <mat-label>Valor de las expensas</mat-label>
                                    <input matInput formControlName="expensas" type="number">
                                    <mat-error *ngIf="rentalSectionFG.controls['expensas'].hasError('required')">
                                        Por favor ingrese un valor para las expensas
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="form-line line-of-three">
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Código de propiedad</mat-label>
                                    <input matInput formControlName="codigo" [attr.disabled]="!!property">
                                    <mat-error *ngIf="rentalSectionFG.controls['codigo'].hasError('required')">
                                        Por favor ingrese un código para la propiedad
                                    </mat-error>
                                    <mat-error *ngIf="rentalSectionFG.controls['codigo'].hasError('notAvailable')">
                                        El valor seleccionado no está disponible
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field property-type" appearance="outline">
                                    <mat-label>Tipo de propiedad</mat-label>
                                    <mat-select formControlName="tipo">
                                        <mat-option *ngFor="let propertyType of propertyTypes" [value]="propertyType.codigo">
                                            {{ propertyType.descripcion }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="rentalSectionFG.controls['tipo'].hasError('required')">
                                        Por favor seleccione un tipo de propiedad
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Cantidad de ambientes</mat-label>
                                    <input matInput type="number" formControlName="cantidadAmbientes">
                                    <mat-error *ngIf="rentalSectionFG.controls['cantidadAmbientes'].hasError('required')">
                                        Por favor ingrese la cantidad de ambientes
                                    </mat-error>
                                    <mat-error *ngIf="rentalSectionFG.controls['cantidadAmbientes'].hasError('min') || rentalSectionFG.controls['cantidadAmbientes'].hasError('pattern')">
                                        Por favor ingrese un número válido
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="form-line" *ngIf="rentalSectionFG.value.tipo === 'COMERCIAL'">
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Porcentaje de actualización</mat-label>
                                    <input matInput formControlName="actualizacion" type="number" style="text-align: right;">
                                    <span matSuffix>&nbsp; %</span>
                                    <mat-error *ngIf="rentalSectionFG.controls['actualizacion'].hasError('required')">
                                        Por favor ingrese el porcentaje de actualización
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Periodo de actualización</mat-label>
                                    <mat-select formControlName="periodoActualizacion">
                                        <mat-option *ngFor="let period of updatePeriods" [value]="period.codigo">
                                            {{ period.descripcion }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="rentalSectionFG.controls['periodoActualizacion'].hasError('required')">
                                        Por favor seleccione el periodo de actualización
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <mat-form-field class="garantor-form-field select-owner" appearance="outline" *ngFor="let control of ownersArray.controls; let i = index">
                                <mat-label>Propietario{{ ownersArray.length > 1 ? ' número ' + (i + 1) : ''}}</mat-label>
                                <input type="text" matInput [formControl]="control" [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                                    <mat-option *ngFor="let owner of owners[i]" [value]="owner" [id]="owner.codigo">
                                        {{ getOwnerName(owner) }} - {{ owner.tipoPersona === 'FISICA' ? owner.personaFisica.dni : owner.personaJuridica.cuit }} - {{ owner.email }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="control.hasError('required') || control.hasError('notSelected')">
                                    Por favor seleccione un propietario de la lista
                                </mat-error>
                                <button mat-icon-button matSuffix type="button" color="accent" class="delete-owner-button" (click)="deleteOwner(i)" *ngIf="i !== 0">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </mat-form-field>
                            <div class="add-owner-container">
                                <div class="add-owner" (click)="addOwner()">
                                    <mat-icon>add_circle</mat-icon>
                                    Agregar propietario
                                </div>
                                <a class="create-owner link" routerLink="/propietarios/nuevo" target="_blank">
                                    <mat-icon>add_circle</mat-icon>
                                    Crear propietario
                                </a>
                            </div>
                            <div class="form-step-buttons owner">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="primary" class="garantor-button next">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createProperty()" *ngIf="property">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step>
                        <ng-template matStepLabel>Resumen</ng-template>
                        <div class="form-step details-form-step">
                            <h3 class="form-step-title">
                                Resumen
                            </h3>
                            <span class="form-step-description">
                                Por favor verifique los datos del nuevo propietario y presione confirmar.
                            </span>
                            <div class="property-details-content-container">
                                <app-property-details-content [property]="getResultingProperty()"></app-property-details-content>
                            </div>
                            <div class="form-step-buttons">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button submit" (click)="createProperty()">Confirmar</button>
                            </div>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
            </mat-tab>
            <mat-tab label="Creación masiva" *ngIf="!property">
                <app-bulk-creator style="width: 100%;" [columnMaps]="bulkCreatorColumnMaps" [getErrorsFn]="getBulkCreatorErrors" [submitFn]="bulkCreatorSubmit"></app-bulk-creator>
            </mat-tab>
        </mat-tab-group>
    </div>
</app-nav>
